import React from 'react';
import { workflowSteps } from '../utils/mockData';
import { ArrowRight } from 'lucide-react';

const WorkflowSection = () => {
  return (
    <section className="section-padding bg-brand-darker">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4">
            <span className="text-white">How It </span>
            <span className="text-brand-hot-pink">Works</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Getting started is simple. Just three steps to viral success.
          </p>
        </div>

        {/* Workflow Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          {/* Connection lines for desktop */}
          <div className="hidden md:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-brand-deep-purple via-brand-vibrant-pink to-brand-coral-orange" 
               style={{ top: '120px', left: '15%', right: '15%' }} />

          {workflowSteps.map((step, index) => (
            <div key={step.id} className="relative animate-fadeInUp" style={{ animationDelay: `${index * 0.15}s` }}>
              {/* Step Number */}
              <div className="flex justify-center mb-6">
                <div className="relative">
                  <div className="step-number text-center">{step.number}</div>
                  <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-brand-gradient rounded-full blur-xl opacity-50" />
                </div>
              </div>

              {/* Content */}
              <div className="text-center">
                <h3 className="text-2xl font-bold text-white mb-4">{step.title}</h3>
                <p className="text-gray-300 leading-relaxed">{step.description}</p>
              </div>

              {/* Arrow (mobile only) */}
              {index < workflowSteps.length - 1 && (
                <div className="md:hidden flex justify-center mt-8">
                  <ArrowRight className="text-brand-hot-pink" size={32} />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="btn-primary text-white px-10 py-5 rounded-full font-bold text-lg inline-flex items-center gap-3 group"
          >
            Start Your Viral Journey
            <ArrowRight className="group-hover:translate-x-1 transition-transform" size={24} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
